import React, { useState, useEffect } from "react";
import Header from "../../components/Header.jsx";
import Footer from "../../components/Footer.jsx";
import Loader from "../../components/Loader.jsx";
import ErrorPage from "../ErrorPage.jsx";
import "../../styles/pages/info_page.css";

import ChevronRightIcon from "../../assets/icons/chevron-right.svg";
import InfoPageImage from "../../assets/images/info_page_image.png";
import UsefullInfoCard from "../../components/UsefullInfoCard";

import { fetchUsefulInformation } from "../../services/apiService.js";
import { formatDate } from "../../utils/dateUtil";

const UsefulInfoPage = () => {
  const [infoData, setInfoData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        const data = await fetchUsefulInformation();
        setInfoData(data);
      } catch (error) {
        setError(error);
        console.error("Ошибка загрузки данных", error);
      } finally {
        setIsLoading(false);
      }
    };

    loadData();
  }, []);

  if (isLoading) {
    return (
      <div className="loader-wrapper">
        <Loader />
        <p className="loading-text">Загрузка...</p>
      </div>
    );
  }

  if (error) {
    return <ErrorPage />;
  }

  return (
    <div className="info-page">
      <Header />

      <nav className="page-nav">
        <a href="/" className="nav-link">Главная</a>
        <img
          src={ChevronRightIcon}
          alt="Chevron"
          className="nav-chevron-icon"
        />
        <a href="/for_clients" className="nav-link">Оптовым клиентам</a>
        <img
          src={ChevronRightIcon}
          alt="Chevron"
          className="nav-chevron-icon"
        />
        <span className="nav-link">Полезная информация</span>
      </nav>

      <div className="info-page-content">
        <h2 className="gradient-page-title">Полезная информация</h2>
        <img
          src={InfoPageImage}
          alt="Useful info pic"
          className="info-image"
        />
        <div className="info-cards-container">
          {infoData.map((item) => (
            <UsefullInfoCard
              key={item.id}
              date={formatDate(item.createdAt)}
              title={item.title}
              description={item.description}
            />
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default UsefulInfoPage;
